import { Link } from "react-router-dom";

import { buttonVariants } from "@/components/ui/button";

export function LogoPreview({ url }: { url: string }) {
  if (!url) return <span className="text-muted-foreground">—</span>;
  const isImage = /\.(png|jpe?g|webp|gif|svg)(\?|$)/i.test(url);
  return (
    <div className="flex items-center gap-3">
      {isImage ? (
        <img
          src={url}
          alt="Uploaded logo"
          className="size-14 rounded border object-contain bg-muted/30"
        />
      ) : null}
      <Link
        to={url}
        target="_blank"
        rel="noreferrer"
        className={buttonVariants({
          variant: "link",
          size: "sm",
          className: "h-auto p-0",
        })}
      >
        View upload
      </Link>
    </div>
  );
}
